import React from "react";
import Buttonlock from "./../carpark/buttonlock";
import { ZoneE, ZoneE2, ZoneF } from "./../carpark/datalist";
const Managercarpark = () => {
  return (
    <div className="container-fluid ">
      
      <div className="row">
  <div className="col-4"></div>
            <div className="col-lg-4 text-center btn btn-primary">
              <span
                
                style={{ fontSize: "30px" }}
              >
                บริหารจัดการลานจอดรถยนต์
              </span>
            </div>
            </div>
      <div className="row">
        <div className="col-lg-6 mt-2">
        </div>
        <div className="col-lg-6 mt-3">
          <div className="row m-2">
           
              
           
            <div className="col-lg-12 text-center ">
              <span
                className="badge rounded-pill bg-info  "
                style={{ fontSize: "20px" }}
              >
                ลานจอดล๊อค E
              </span>
            </div>
          </div>
          <div className="row m-2">
            {/* <div className="col-lg-4 ">
              <i className="bi bi-check-circle-fill text-d"></i>
            </div> */}
            <div className="row col-lg-12 d-flex justify-content-center">
              <Buttonlock list={ZoneE} />
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-4 "></div>
            <div className="row  col-lg-12 d-flex justify-content-center ">
              <Buttonlock list={ZoneE2} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mt-3">
          <div className="row m-1 ">
            <div className="col-lg-12 d-flex justify-content-center">
              <span
                className="badge rounded-pill bg-info  "
                style={{ fontSize: "20px" }}
              >
                ลานจอดล๊อค B
              </span>
            </div>
          </div>
          <div className="row">

            <div className="row m-2">
              <div className="col-lg-12 ">
                <Buttonlock list={ZoneE2} />

              </div>
            </div>
            <div className="row m-2">
              <div className="col-lg-12 ">
                <Buttonlock list={ZoneE} />

              </div>
            </div>

          </div>
        </div>
        <div className="col-lg-6 mt-4">
          <div className="row m-2">
            {/* <div className="col-lg-12 ">
              <i className="bi bi-check-circle-fill text-d"></i>
            </div> */}
            <div className="col-lg-12 text-center ">
              <span
                className="badge rounded-pill bg-info  "
                style={{ fontSize: "20px" }}
              >
                ลานจอดล๊อค C
              </span>
            </div>
          </div>
          <div className="row m-2">
            {/* <div className="col-lg-4 ">
              <i className="bi bi-check-circle-fill text-d"></i>
            </div> */}
            <div className="row col-lg-12 d-flex justify-content-center">
              <Buttonlock list={ZoneE} />
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-4 "></div>
            <div className="row  col-lg-12 d-flex justify-content-center ">
              <Buttonlock list={ZoneE2} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6 mt-3">
          <div className="row m-1 ">
            <div className="col-lg-12 d-flex justify-content-center">
              <span
                className="badge rounded-pill bg-info  "
                style={{ fontSize: "20px" }}
              >
                ลานจอดล๊อค A
              </span>
            </div>
          </div>
          <div className="row">

            <div className="row m-2">
              <div className="col-lg-12 ">
                <Buttonlock list={ZoneE2} />

              </div>
            </div>
            <div className="row m-2">
              <div className="col-lg-12 ">
                <Buttonlock list={ZoneE} />

              </div>
            </div>

          </div>
        </div>
        <div className="col-lg-6 mt-3">
          <div className="row m-2">
            {/* <div className="col-lg-12 ">
              <i className="bi bi-check-circle-fill text-d"></i>
            </div> */}
            <div className="col-lg-12 text-center ">
              <span
                className="badge rounded-pill bg-info  "
                style={{ fontSize: "20px" }}
              >
                ลานจอดล๊อค D
              </span>
            </div>
          </div>
          <div className="row m-2">
            {/* <div className="col-lg-4 ">
              <i className="bi bi-check-circle-fill text-d"></i>
            </div> */}
            <div className="row col-lg-12 d-flex justify-content-center">
              <Buttonlock list={ZoneE} />
            </div>
          </div>

          <div className="row m-2">
            <div className="col-lg-4 "></div>
            <div className="row  col-lg-12 d-flex justify-content-center ">
              <Buttonlock list={ZoneE2} />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 mt-3">
          <div className="row m-1 ">
            <div className="col-lg-12 d-flex justify-content-center">
              <span
                className="badge rounded-pill bg-info  "
                style={{ fontSize: "20px" }}
              >
                ลานจอดล๊อค F
              </span>
            </div>
          </div>
          <div className="row">

            <div className="row m-2">
              <div className="col-lg-12 ">
                <Buttonlock list={ZoneF} />

              </div>
            </div>


          </div>
        </div>

      </div>
    </div>
  );
};

export default Managercarpark;
